// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b685d243","239":"58cfec8a","453":"6180d201","455":"097771d1","762":"aeeb8935","841":"3a8b7421"}[chunkId] + ".chunk.js";
};